import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';
import shortid from "shortid";

const PergamumKidsRequest = () => {
    const fns = {
        getSections: (library_id, cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/sections/${library_id}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        getLibraries: (cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/libraries`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        checkInstitutionPermission: (cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/check-institution-permission`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        getCategories: (library_id, cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/categories/${library_id}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        getSearch(searchText, codBiblioteca, codCategoria, page, cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/search-kids`,
                { headers: BaseRequest.publicHeaders, params: { searchText, codBiblioteca, codCategoria, page, search_id: shortid.generate() }, cancelToken },
            );
        },
        getDefaultBgAndLogo(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/instituicao/imagem-e-logo-padrao`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        getDadosAcervo(codAcervo, codBiblioteca, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/dados-acervo/${codAcervo}/${codBiblioteca}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        getVitrineButtons(codBiblioteca, cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/vitrine-buttons/${codBiblioteca}`,
                { headers: BaseRequest.publicHeaders, params: {search_id: shortid.generate()}, cancelToken},
            );
        },
        getLabelsDadosAcervo: (codBiblioteca, cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/dados-acervo/labels/${codBiblioteca}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        getLocalizacaoAcervo: (codAcervo, codBiblioteca, cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/localizacao/${codAcervo}/${codBiblioteca}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },

        getVisual: (codBiblioteca, cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/visual/${codBiblioteca}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        verifyCategory: (cod_biblioteca, cod_categoria,cancelToken = null) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/categoria/verificar/${cod_biblioteca}/${cod_categoria}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        getLabels: (cod_biblioteca, cancelToken) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/labels/${cod_biblioteca}`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        buscarDestaques: (codBiblioteca) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/destaques/${codBiblioteca}`,
                { headers: BaseRequest.publicHeaders},
            );
        },
        buscarNoticias: (cod_pagina, cancelToken) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/noticias`,
                { headers: BaseRequest.publicHeaders, params: {cod_pagina}, cancelToken},
            );
        },
        buscarDadosAcabaramDeChegar(){
            return BaseRequest.axiosInst.get(
                `${API_URL}/pergamum-kids/acabaram_de_chegar`,
                { headers: BaseRequest.publicHeaders, params: {search_id: shortid.generate()}},
            );
        }
    }

    return fns;
}

export default PergamumKidsRequest();
